import { useEffect, useState } from "react";
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import "./PujaListPageDesign.css";
const PujaPageSections = ({ pujaDetailsData, FAQ, t }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [readMoreDetailed, setReadMoreDetailed] = useState(false);
  const maxChars = 500;

  const detailedText = (() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = pujaDetailsData?.pujaDetails || "";
    return tempDiv.innerText || tempDiv.textContent || "";
  })();

  // Dynamically set categories based on available content
  useEffect(() => {
    const newCategories = [];

    if (pujaDetailsData?.pujaDetails) {
      newCategories.push({
        value: "description",
        label: "Description",
        ID: "descriptionSection",
      });
    }

    if (pujaDetailsData?.keyFeature) {
      newCategories.push({
        value: "keyFeature",
        label: "Key Features",
        ID: "keyFeatureSection",
      });
    }
    if (
      pujaDetailsData?.pujaSamagri &&
      pujaDetailsData?.CategoryType !== "Deepdaan"
    ) {
      newCategories.push({
        value: "samagri",
        label: "Samagri",
        ID: "samagriSection",
      });
    }


    if (FAQ?.length > 0) {
      newCategories.push({ value: "faq", label: "FAQs", ID: "faqSection" });
    }

    setCategories(newCategories);

    if (newCategories.length > 0) {
      setActiveCategory(newCategories[0].value); // default first tab
    }
  }, [pujaDetailsData, FAQ]);

  const scrollToSection = (ID) => {
    const section = document.getElementById(ID);
    if (section) {
      const offset = 120; // adjust for sticky headers
      const topPos =
        section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: topPos, behavior: "smooth" });
    }
  };

  return (
    <div>
      {/* Tabs */}
      <div
        className="category-tabs-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "8px 0",
          background: "linear-gradient(135deg, #a52444, #7e1c36)",
          marginTop: "60px",
          borderRadius: "20px",
          marginBottom: "60px",
        }}
      >
        <ul
          className="nav justify-content-center mobile-detail-tab"
          style={{
            display: "flex",
            listStyle: "none",
            margin: 0,
            padding: 0,
            flexWrap: "wrap",
            gap: "25px",
            background: "rgba(255, 255, 255, 0.08)",
            padding: "3px 7px",
            borderRadius: "50px",
            boxShadow: "inset 0 0 15px rgba(255,255,255,0.1)",
            backdropFilter: "blur(8px)",
          }}
        >
          {categories.map((cat) => (
            <li
              className="nav-item"
              key={cat.value}
              style={{
                margin: "5px",
              }}
            >
              <button
                className={`nav-link-blog category-tab-btn ${activeCategory === cat.value ? "active" : "InActive"
                  }`}
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  padding: "6px 28px",
                  borderRadius: "30px",
                  border: "none",
                  background:
                    activeCategory === cat.value
                      ? "linear-gradient(135deg, #ffa415, #ffc45c)"
                      : "rgba(255,255,255,0.15)",
                  color: activeCategory === cat.value ? "#a52444" : "#fff",
                  boxShadow:
                    activeCategory === cat.value
                      ? "0 4px 20px rgba(255,164,21,0.5)"
                      : "0 2px 8px rgba(0,0,0,0.2)",
                  cursor: "pointer",
                  transition: "all 0.4s ease",
                  transform: activeCategory === cat.value ? "scale(1.05)" : "scale(1)",
                  backdropFilter: "blur(4px)",
                }}
                onMouseOver={(e) => {
                  e.target.style.background =
                    activeCategory === cat.value
                      ? "linear-gradient(135deg, #ffb733, #ffe07a)"
                      : "rgba(255,255,255,0.3)";
                  e.target.style.transform = "scale(1.08)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background =
                    activeCategory === cat.value
                      ? "linear-gradient(135deg, #ffa415, #ffc45c)"
                      : "rgba(255,255,255,0.15)";
                  e.target.style.transform =
                    activeCategory === cat.value ? "scale(1.05)" : "scale(1)";
                }}
                onClick={() => {
                  setActiveCategory(cat.value);
                  scrollToSection(cat.ID);
                }}
              >
                {t(cat.label)}
              </button>
            </li>
          ))}
        </ul>
      </div>


      {/* Sections */}
      {pujaDetailsData?.pujaDetails && (
        <div
          id="descriptionSection"
          className="detailed-description mt-4"
        >
          <div className="section-title text-center">
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ textAlign: "center" }}
            >
              {/* Book Puja Services At your Fingertips */}
              {t("Description")}
            </h3>
          </div>
          {/* Wrap text + button together */}
          <div style={{ display: "inline" }}>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  readMoreDetailed || detailedText.length <= maxChars
                    ? pujaDetailsData?.pujaDetails
                    : detailedText.substring(0, maxChars) + "...",
              }}
            />

            {detailedText.length > maxChars && (
              <span
                onClick={() => setReadMoreDetailed(!readMoreDetailed)}
                style={{
                  color: "#a52444",
                  cursor: "pointer",
                  marginLeft: "8px",
                  verticalAlign: "baseline",
                }}
              >
                {readMoreDetailed ? t("Read Less") : t("Read More")}
              </span>
            )}
            <div className="about-one__content__border"></div>
          </div>
        </div>
      )}

      {pujaDetailsData?.keyFeature && (
        <div id="keyFeatureSection" className="detailed-description mt-4 ">
          <div className="section-title text-center">
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ textAlign: "center" }}
            >
              {/* Book Puja Services At your Fingertips */}
              {t("Key Features")}
            </h3>
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: pujaDetailsData.keyFeature }}
          />
          <div className="about-one__content__border"></div>
        </div>
      )}
      {pujaDetailsData?.pujaSamagri &&
        pujaDetailsData?.CategoryType !== "Deepdaan" && (
          <div id="samagriSection" className="detailed-description mt-4 ">
            {/* <h5 className="d-flex justify-content-center">{t("Samagri")}</h5> */}
            <div className="section-title text-center">
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ textAlign: "center" }}
              >
                {/* Book Puja Services At your Fingertips */}
                {t("Samagri")}
              </h3>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: pujaDetailsData.pujaSamagri }}
            />
            <div className="about-one__content__border"></div>
          </div>
        )}



      {FAQ?.length > 0 && (
        <div id="faqSection" className="faq-section mt-4 ">
          <section className="faq-one faq-one--page">
            <div
              className="container"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="section-title text-center">
                <h5
                  className="sec-title__tagline bw-split-in-right d-flex justify-content-center"
                  style={{
                    perspective: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img className="tagline-img" src={pandit} alt="" />{" "}
                  {t("FAQs")}
                </h5>
                <h3
                  className="sec-title__title bw-split-in-left"
                  style={{ perspective: "400px", textAlign: "center" }}
                >
                  {t("Frequently Asked Questions")}.
                </h3>
              </div>
              <div className="row">
                <div className="col-xl-2"></div>
                <div className="col-xl-8">
                  <div className="faq-one__accordion careox-accordion">
                    {FAQ.map((item, index) => (
                      <div key={index}>
                        <strong>{item.question}</strong>
                        <p>{item.answer}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-xl-2"></div>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default PujaPageSections;
